/**
 * One icon per account type, so the account chips read at a glance on a phone.
 *
 * Same approach as the category and navigation icons: hand-drawn inline SVG following
 * `currentColor`.
 */
import type { AccountType } from '@pfo/domain';

const line = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

function Glyph({ children }: { children: React.ReactNode }) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <g {...line}>{children}</g>
    </svg>
  );
}

const GLYPHS: Record<AccountType, React.ReactNode> = {
  cash: (
    <>
      <rect x="3" y="7" width="18" height="10" rx="2" />
      <circle cx="12" cy="12" r="2.4" />
    </>
  ),
  bank: (
    <>
      <path d="M3.5 9.5 12 4.5l8.5 5" />
      <path d="M5.5 9.5v8M18.5 9.5v8M9.5 9.5v8M14.5 9.5v8" />
      <path d="M3.5 19.5h17" />
    </>
  ),
  e_wallet: (
    <>
      <rect x="6.5" y="3" width="11" height="18" rx="2.2" />
      <path d="M10.5 17.5h3" />
    </>
  ),
  broker_cash: (
    <>
      <rect x="3" y="7" width="18" height="10" rx="2" />
      <path d="M8 12h8" />
    </>
  ),
  broker_investment: (
    <>
      <path d="M4 18V6M4 18h16" />
      <path d="M8 15l3.5-4 3 2.5L20 8" />
    </>
  ),
  savings: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v8M9.5 10.2h5M9.5 13.8h5" />
    </>
  ),
  other_asset: (
    <>
      <path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5z" />
      <path d="M4 8.5 12 13l8-4.5M12 13v7" />
    </>
  ),
  liability: (
    <>
      <path d="M6 4h9l4 4v12H6z" />
      <path d="M9.5 12h5M9.5 15.5h5" />
    </>
  ),
  credit_card: (
    <>
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M3 10h18" />
      <path d="M6.5 14.5h3" />
    </>
  ),
};

export function AccountTypeIcon({ accountType }: { accountType: AccountType }) {
  return <Glyph>{GLYPHS[accountType]}</Glyph>;
}
